<template>
    <div>
        <template v-if="$store.state.userInfo.email">
            <!--            <div class="main-wrapper ho-ho-ho">-->
            <Header />
            <!--                <Navigation />-->
            <div class="main-wrapper__content">
                <div class="main-wrapper__content--sidebar" v-if="!isTestMechanic">
                    <div class="container-fluid">
                        <Sidebar />
                    </div>
                </div>
                <div class="main-wrapper__content--current-page">
                    <div class="container-fluid">
                        <router-view />
                    </div>
                </div>
            </div>
            <!--            </div>-->
            <Footer v-if="!isTestMechanic" />
            <SessionExpiredModal :count="$root.count" />
        </template>


        <template v-else="isBusy">
            <Preloader />
        </template>
    </div>

</template>

<script>
import Preloader from '@/components/Preloader'
import Header from '@/components/Header';
import Navigation from '@/components/Navigation';
import Sidebar from '@/components/Sidebar';
import Footer from '@/components/Footer';
import SessionExpiredModal from '@/components/SessionExpiredModal'
import { onBeforeMount } from 'vue';

export default {
    name: 'MechanicSide',
    components: {
        Header,
        Navigation,
        Preloader,
        Sidebar,
        Footer,
        SessionExpiredModal
    },
    computed: {
        isUserLogged() {
            return this.$store.getters.getAuthUserInfo.id;
        },
        isTestMechanic() {
            return this.$store.getters.isTest;
        }
    },
    methods: {
        updateUserInfo() {
            let url = 'auth/user';
            this.apiGet(url).then(response => {
                if (response.data.data) {
                    this.$store.dispatch('signIn', {
                        access_token: this.$ls.getItem('access_token'),
                        data: response.data.data
                    });
                    this.$store.dispatch('updateCalcGaranties', response.data.data.calcQuotes);
                }
            });
        },
    },
    mounted() {
        this.updateUserInfo();
    },
    watch: {
        isTestMechanic: {
            immediate: true,
            handler(val) {
                if (val) {
                    import('../scss/styleV2.scss');
                }
            }
        }
    }

}
</script>



// WEBPACK FOOTER //
// src/components/MechanicSide.vue